// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:29Z                      #

// ##############################################################


/**
 * 
 */
enum SignRequestSource {
    MANUALLY = 'MANUALLY', 
    EXTERNAL = 'EXTERNAL'
};
export default SignRequestSource;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [SignRequestSource.MANUALLY]: {caption: ''},
    [SignRequestSource.EXTERNAL]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
